import { render, staticRenderFns } from "./MainChartTabs.vue?vue&type=template&id=4c46a330&scoped=true&"
import script from "./MainChartTabs.vue?vue&type=script&lang=js&"
export * from "./MainChartTabs.vue?vue&type=script&lang=js&"
import style0 from "./MainChartTabs.vue?vue&type=style&index=0&id=4c46a330&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c46a330",
  null
  
)

export default component.exports